/**
 * Route definitions for store-front
 */

export enum routes {
    // Store Front routes
    WELCOME = '/',
    PRELOADER = '/preloader',
    OFFERS = '/offers',
    FORGOT_PASSWORD = '/forgot-passcode',
    RECEIVE_OFFER = '/receive-offer',
    USER_DETAILS = '/user-details',
    HELP = '/help',
    DASHBOARD = '/dashboard',
}

/**
 * Route parameter replacement helper
 */
export interface RouteParameters {
    [parameter: string]: string;
}

export const replaceRouteParams = (routeTemplate: routes, params: RouteParameters): string => {
    return Object.keys(params).reduce((memo, paramName) => {
        return memo.replace(`:${paramName}`, params[paramName]);
    }, routeTemplate as string);
};

/**
 * Check if a path matches a route
 */
export const isValidRoute = (path: string): path is routes => {
    return Object.values(routes).includes(path as routes);
};
